import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';

import { SetCurrentCodeSection, SetCurrentCodePage } from '../shared/navigation.state';

@Component({
  selector: 'app-offre-achat',
  templateUrl: './offre-achat.component.html',
  standalone: false
})
export class OffreAchatComponent implements OnInit {
  constructor(private readonly _router: Router, private readonly _store: Store) {}

  ngOnInit() {
    this._store.dispatch(new SetCurrentCodeSection('OFFRE'));
    this._store.dispatch(new SetCurrentCodePage('offre_achat'));
  }

  navigateTo(target: string): void {
    this._router.navigateByUrl(target);
  }
}
